export const BROWSE = 'Browse'
export const UPLOAD = 'Upload'
export const DOWNLOAD_TEMPLATE_LABEL = 'Download Pacing Dates Template'
export const DOWNLOAD_RESULTS_LABEL = 'Click to Download Results'
export const LOADING_MESSAGE = 'Processing file....'
export const EXAMPLE_IMAGE_INSTRUCTION =
  'All uploaded spreadsheets should be formatted like this:'

export const TEMPLATE_FILENAME = 'bulk_pacing_template.csv'
export const RESULTS_FILENAME_SUFFIX = '_bulk_pacing_dates_results.csv'
